import { PayloadAction } from '../../../../../store.model';
import { createFilteredQuotesLookup } from '../function/create-filtered-quotes-lookup.function';
import { filterQuotesByDateTimeRange } from '../function/filter-quotes-by-datetime-range.function';
import { filterQuotesByKeyword } from '../function/filter-quotes-by-keyword.function';
import { filterQuotesByParticipants } from '../function/filter-quotes-by-participants.function';
import { ActionType } from '../teamschat-transcript-dialog.action';
import { TeamschatTranscriptDialogState } from '../teamschat-transcript-dialog.state';

import { FilterQuotes } from './filter-quotes.action';

export function filterQuotesReducer(
    state: TeamschatTranscriptDialogState,
    action: PayloadAction<
        ActionType.COACHING_DETAIL__TCTD__FILTER_QUOTES,
        FilterQuotes
    >,
): TeamschatTranscriptDialogState {
    try {
        let nextFiltered = filterQuotesByParticipants(
            action.payload.opts.members ?? null,
            state?.messages ?? [],
        );
        nextFiltered = filterQuotesByKeyword(
            action.payload.opts.keyword ?? null,
            nextFiltered,
        );
        nextFiltered = filterQuotesByDateTimeRange(
            action.payload.opts.dateRange,
            nextFiltered,
        );

        const { lookup: nextLookup, all: nextAllQuotesAreSelected } =
            createFilteredQuotesLookup(
                nextFiltered,
                state.selectedQuotes ?? [],
            );

        return {
            ...state,
            filteredQuotes: nextFiltered,
            filterOpts: action.payload.opts,
            filteredQuotesSelectedLookup: nextLookup,
            allQuotesAreSelected: nextAllQuotesAreSelected,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
